import $ from 'jquery'; 

function linkPills(){
    //Pill script
    $('.PillTabs > button').on('click',function() {
        //console.log("click event!");
       // console.log($(this)[0]);
        $(this).css({
            'color':'#61A60E',
            'background-color':'white',
            'border':'2px solid #61A60E'
        });
        let toShow = $(this)[0].value;
        $('.PillContainer').each(function(index, ele){
        //console.log(ele.id);
            if (ele.id != toShow){
                $('button[value='+ ele.id +']').css({
                'color':'',
                'background-color':'',
                'border':''
            });
                $(ele).hide();
            } else {
                $(ele).fadeIn();
            }
        });
    });
    $('.PillTabs > button')[0].click();
    
    return (null)
 }
 export default linkPills